import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// nexaios's actual fonts (app/layout.tsx: next/font/local + next/font/google), not a generic
// system stack. Self-hosted via fontsource rather than vendoring the TTF files across repos —
// same font, same weights (Plus Jakarta Sans 400–800, DM Mono 400), same rendering. Imported as
// JS, not a CSS @import — Vite only rebases/copies the woff2 url() references correctly this way.
import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource/dm-mono/400.css';
import './tailwind.css';
import './app.scss';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
